const JournalInstructions = () => (
    <div className="instructions">
        <h2>Garden Journal Instructions</h2>
        <ul>
            <p>You are viewing your garden journal. You can look at specific years viewing your crop that year,</p>
            <p>or a specific crop across all years.</p>
            <p>You can update information for the current year only.</p>
            <p>Adjust cell data and then press submit to save your changes.</p>
        </ul>

    </div>
);
export default JournalInstructions;
